import { useEffect, useState } from "react";

function PainelOfertas() {
  const [form, setForm] = useState({
    nome: "",
    link: "",
    codigoPromocional: "",
    cashback: "",
    imagemUrl: "",
    descricao: "",
  });

  const [editandoId, setEditandoId] = useState(null);
  const [ofertas, setOfertas] = useState([]);
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const fetchOfertas = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/ofertas`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setOfertas(data);
    } catch (err) {
      console.error("Erro ao buscar ofertas:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensagem("");

    try {
      const token = localStorage.getItem("token");
      const url = `${process.env.REACT_APP_API_URL}/api/admin/ofertas${editandoId ? `/${editandoId}` : ""}`;
      const metodo = editandoId ? "PUT" : "POST";

      const body = {
        nome: form.nome,
        link: form.link,
        codigoPromocional: form.codigoPromocional,
        cashback: form.cashback,
        imagemUrl: form.imagemUrl,
        descricao: form.descricao,
      };

      const res = await fetch(url, {
        method: metodo,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (res.ok) {
        setMensagem(editandoId ? "✅ Oferta atualizada com sucesso!" : "✅ Oferta criada com sucesso!");
        setForm({
          nome: "",
          link: "",
          codigoPromocional: "",
          cashback: "",
          imagemUrl: "",
          descricao: "",
        });
        setEditandoId(null);
        fetchOfertas();
      } else {
        const data = await res.json();
        setMensagem(data.error || "Erro ao salvar.");
      }
    } catch (error) {
      console.error("Erro ao salvar oferta:", error);
      setMensagem("Erro ao salvar oferta.");
    } finally {
      setLoading(false);
    }
  };

  const handleExcluir = async (id) => {
    if (!window.confirm("Tem certeza que deseja excluir esta oferta?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/ofertas/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        setOfertas((prev) => prev.filter((oferta) => oferta.id !== id));
        setMensagem("Oferta excluída com sucesso.");
      } else {
        const data = await res.json();
        setMensagem(data.error || "Erro ao excluir oferta.");
      }
    } catch (err) {
      console.error("Erro ao excluir oferta:", err);
      setMensagem("Erro ao excluir oferta.");
    }
  };

  const handleEditar = (oferta) => {
    setForm({
      nome: oferta.nome,
      link: oferta.link,
      codigoPromocional: oferta.codigoPromocional,
      cashback: oferta.cashback,
      imagemUrl: oferta.imagemUrl,
      descricao: oferta.descricao,
    });
    setEditandoId(oferta.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancelarEdicao = () => {
    setEditandoId(null);
    setForm({
      nome: "",
      link: "",
      codigoPromocional: "",
      cashback: "",
      imagemUrl: "",
      descricao: "",
    });
  };

  useEffect(() => {
    fetchOfertas();
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Painel de Casas de Aposta</h2>

      {mensagem && (
        <div className="mb-4 bg-green-100 text-green-700 border border-green-400 p-2 rounded">
          {mensagem}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-3 mb-6">
        <input
          name="nome"
          value={form.nome}
          onChange={handleChange}
          placeholder="Nome"
          className="w-full p-2 border rounded"
          required
        />
        <input
          name="link"
          value={form.link}
          onChange={handleChange}
          placeholder="Link"
          className="w-full p-2 border rounded"
          required
        />
        <input
          name="codigoPromocional"
          value={form.codigoPromocional}
          onChange={handleChange}
          placeholder="Código Promocional"
          className="w-full p-2 border rounded"
        />
        <input
          name="cashback"
          type="number"
          step="0.01"
          value={form.cashback}
          onChange={handleChange}
          placeholder="Cashback"
          className="w-full p-2 border rounded"
          required
        />
        <input
          name="imagemUrl"
          value={form.imagemUrl}
          onChange={handleChange}
          placeholder="Cole aqui a URL da imagem"
          className="w-full p-2 border rounded"
          required
        />
        <textarea
          name="descricao"
          value={form.descricao}
          onChange={handleChange}
          placeholder="Descrição detalhada da oferta"
          className="w-full p-2 border rounded h-32"
          required
        />

        <div className="flex gap-3">
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-800 text-white px-4 py-2 rounded"
          >
            {loading ? "Salvando..." : editandoId ? "Atualizar Oferta" : "Salvar Oferta"}
          </button>
          {editandoId && (
            <button
              type="button"
              onClick={handleCancelarEdicao}
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
            >
              Cancelar Edição
            </button>
          )}
        </div>
      </form>

      <h3 className="text-lg font-semibold mb-2">Casas cadastradas</h3>
      <table className="w-full border border-gray-300 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">Nome</th>
            <th className="p-2 border">Cashback</th>
            <th className="p-2 border">Promo</th>
            <th className="p-2 border">Ações</th>
          </tr>
        </thead>
        <tbody>
          {ofertas.map((oferta) => (
            <tr key={oferta.id}>
              <td className="border p-2">{oferta.nome}</td>
              <td className="border p-2">{oferta.cashback}%</td>
              <td className="border p-2">{oferta.codigoPromocional}</td>
              <td className="border p-2 space-x-2">
                <button
                  className="text-blue-600 hover:underline"
                  onClick={() => handleEditar(oferta)}
                >
                  Editar
                </button>
                <button
                  className="text-red-600 hover:underline"
                  onClick={() => handleExcluir(oferta.id)}
                >
                  Excluir
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PainelOfertas;


